export var Timezone;
(function (Timezone) {
    Timezone["americaAdak"] = "America/Adak - UTC-10";
    Timezone["pacificHonolulu"] = "Pacific/Honolulu - UTC-10";
    Timezone["americaAnchorage"] = "America/Anchorage - UTC-9";
    Timezone["americaJuneau"] = "America/Juneau - UTC-9";
    Timezone["americaMetlakatla"] = "America/Metlakatla - UTC-9";
    Timezone["americaNome"] = "America/Nome - UTC-9";
    Timezone["americaSitka"] = "America/Sitka - UTC-9";
    Timezone["americaYakutat"] = "America/Yakutat - UTC-9";
    Timezone["americaLosAngeles"] = "America/Los_Angeles - UTC-8";
    Timezone["americaBoise"] = "America/Boise - UTC-7";
    Timezone["americaDenver"] = "America/Denver - UTC-7";
    Timezone["americaPhoenix"] = "America/Phoenix - UTC-7";
    Timezone["americaChicago"] = "America/Chicago - UTC-6";
    Timezone["americaIndianaKnox"] = "America/Indiana/Knox - UTC-6";
    Timezone["americaIndianaTellCity"] = "America/Indiana/Tell_City - UTC-6";
    Timezone["americaMenominee"] = "America/Menominee - UTC-6";
    Timezone["americaNorthDakotaBeulah"] = "America/North_Dakota/Beulah - UTC-6";
    Timezone["americaNorthDakotaCenter"] = "America/North_Dakota/Center - UTC-6";
    Timezone["americaNorthDakotaNewSalem"] = "America/North_Dakota/New_Salem - UTC-6";
    Timezone["americaDetroit"] = "America/Detroit - UTC-5";
    Timezone["americaIndianaIndianapolis"] = "America/Indiana/Indianapolis - UTC-5";
    Timezone["americaIndianaMarengo"] = "America/Indiana/Marengo - UTC-5";
    Timezone["americaIndianaPetersburg"] = "America/Indiana/Petersburg - UTC-5";
    Timezone["americaIndianaVevay"] = "America/Indiana/Vevay - UTC-5";
    Timezone["americaIndianaVincennes"] = "America/Indiana/Vincennes - UTC-5";
    Timezone["americaIndianaWinamac"] = "America/Indiana/Winamac - UTC-5";
    Timezone["americaKentuckyLouisville"] = "America/Kentucky/Louisville - UTC-5";
    Timezone["americaKentuckyMonticello"] = "America/Kentucky/Monticello - UTC-5";
    Timezone["americaNewYork"] = "America/New_York - UTC-5";
})(Timezone || (Timezone = {}));
//# sourceMappingURL=time.js.map